module.exports = __webpack_public_path__ + "img/Networking.82467da0.png";